import { render } from "./MaintenancePage.vue?vue&type=template&id=0c2ac055&ts=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts"

import "./MaintenancePage.vue?vue&type=style&index=0&id=0c2ac055&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__